'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var noCreateAllowedFor = new Set(['categoryOptionCombo']);

exports.noCreateAllowedFor = noCreateAllowedFor;
exports['default'] = {
    baseUrl: '/api',
    i18n: {
        sources: new Set(),
        strings: new Set()
    }
};
//# sourceMappingURL=defaultConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/defaultConfig.js
// module id = 199
// module chunks = 0